module.exports = __webpack_public_path__ + "static/img/Samsung.f5c1ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Samsung.png
// module id = TKTs
// module chunks = 7